module.exports = __webpack_public_path__ + "img/human-resources-businessman.b3113ef5.svg";